import { Injectable } from '@angular/core';
import {
  ensureSessionProjectTokens,
  getActiveProjectId,
  getProjectSwitcherItems,
  readProjectTokens,
  shouldShowProjectSwitcher,
  switchProject,
  type ProjectSwitcherItem,
  type ProjectTokenEntry,
} from '@insite-store360/auth-session';

export type { ProjectSwitcherItem, ProjectTokenEntry };

/**
 * Owns multi-project session switching for the IntElux header.
 * Delegates token/path rules to the shared auth-session contract used by SPFT.
 */
@Injectable({
  providedIn: 'root',
})
export class ProjectSwitcherService {
  private projectList: ProjectTokenEntry[] = [];
  private activeProjectId: number | null = null;

  public loadFromStorage(): void {
    // Rehydrate IntElux (+ toggle PM) into project-tokens. Backend omits
    // Project 1 from login response.projects; toggle PM has no projectId=2 JWT.
    const pmRoleId = Number(localStorage.getItem('projectManagementRoleId'));
    const enriched = ensureSessionProjectTokens(readProjectTokens(), {
      hasPmAccess: localStorage.getItem('IsProjectManagement') === 'true',
      projectManagementRoleId: Number.isFinite(pmRoleId) ? pmRoleId : null,
    });
    if (enriched.length) {
      localStorage.setItem('project-tokens', JSON.stringify(enriched));
    }
    this.projectList = enriched;
    this.activeProjectId = getActiveProjectId(this.projectList);
  }

  public getActiveProjectId(): number | null {
    return this.activeProjectId;
  }

  public getSwitcherItems(): ProjectSwitcherItem[] {
    return getProjectSwitcherItems(this.projectList);
  }

  public shouldShowSwitcher(): boolean {
    return shouldShowProjectSwitcher(this.projectList);
  }

  public switchTo(projectId: number | null, appPath: string): void {
    switchProject(projectId, appPath);
    this.activeProjectId = projectId;
  }
}
